import { Box } from "@mui/material";
import { APIProvider } from "@vis.gl/react-google-maps";
import MapLoadingCover from "./MapLoadingCover";
//Incluye el ApiProvider para que el mapa se pueda usar en el frame.
const GoogleMapFrame = ({ apiKey, libraries = ["marker", "geometry"], children }) => (
  <APIProvider apiKey={apiKey} libraries={libraries}>
    <Box sx={{ position: "relative", height: "100vh", width: "100%" }}>
      {children}
      <MapLoadingCover />
    </Box>
  </APIProvider>
);

export default GoogleMapFrame;
